import { IonLoading } from '@ionic/react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { selectIsLoading } from '../../store/slices/loading.slice';

/**
 * A global spinner that is shown whenever isLoading is set to true from the useLoading hook
 */
export const RootLoader = () => {
  const isLoading = useSelector(selectIsLoading);
  const location = useLocation();

  return (
    <IonLoading
      isOpen={isLoading}
      spinner="crescent"
      style={{
        '--background': 'none',
        ...(location.pathname === '/track'
          ? { '--backdrop-opacity': '0' }
          : {}), //remove backdrop while recording songCard
      }}
    />
  );
};
